export default __webpack_public_path__ + "static/media/detalii_apartament_44-min.95cb16fd.jpg";